import { SPRITE_ICON_BASE_URL } from '../constants';

import type { SpriteIconAssets } from '../types';

export default function getSpriteIconInitialAssets(category: string, id: string): SpriteIconAssets {
  return {
    alt: `${category}_${id}_icon`,
    placeholder: `${SPRITE_ICON_BASE_URL}/icons/${category}/sprite.svg#skeleton`,
    src: `${SPRITE_ICON_BASE_URL}/icons/${category}/sprite.svg#${id}`,
  };
}
